import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '@/assets/image/30.png';
const _hoisted_1 = {
  class: "help"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "list_title"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "right"
};
const _hoisted_7 = {
  class: "head"
};
const _hoisted_8 = ["innerHTML"];
import { ref, computed, onMounted } from 'vue';
import { leftList } from './json.js';
export default {
  __name: 'index',
  setup(__props) {
    const info = ref({});
    onMounted(() => {
      info.value = {
        id: leftList[0].id,
        title: leftList[0].title,
        ids: leftList[0].list[0].ids,
        son_title: leftList[0].list[0].title,
        son_des: leftList[0].list[0].des
      };
    });
    const issueChange = (item, v) => {
      info.value = {
        id: item.id,
        title: item.title,
        ids: v.ids,
        son_title: v.title,
        son_des: v.des
      };
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "banner"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }), _createElementVNode("div", {
        class: "title"
      }, "帮助中心")], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leftList), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "list"
        }, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (v, i) => {
          return _openBlock(), _createElementBlock("div", {
            onClick: $event => issueChange(item, v),
            key: i,
            class: _normalizeClass(info.value.id == item.id && info.value.ids == v.ids ? 'checked list_des' : 'list_des')
          }, _toDisplayString(v.title), 11, _hoisted_5);
        }), 128))]);
      }), 128))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(info.value.title), 1), _createElementVNode("span", null, _toDisplayString(info.value.son_title), 1)]), _createElementVNode("div", {
        innerHTML: info.value.son_des,
        class: "des"
      }, null, 8, _hoisted_8)])])]);
    };
  }
};